import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { RadioGroup, FormControlLabel } from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import { setSelectedNode, setNodeById } from '../../../features/mainSlice';
import { color } from '../../../app/theme';
import { TriggerFlowModeType } from '../../../app/types';
import isSun from '../../../assets/images/svg/ic-sun.svg';

const useStyles = makeStyles(
  {
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
    item: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
    },
    sun: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$15,
      width: 80,
      borderRadius: '20px',
      justifyContent: 'center',
      padding: '2px 0',
      marginBottom: 6,
    },
    mode: {
      marginBottom: 44,
    },
    hint: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
    },
  },
  {
    name: 'Flow',
  },
);

const Flow = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { data } = selectedNode || {};
  const { type } = data || {};

  const onChange = event => {
    const newNode = {
      ...selectedNode,
      data: {
        ...data,
        type: event.target.value,
      },
    };

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  return (
    <>
      <div className={classes.mode}>
        <div className={classes.title}>{t('trigger-setting.flow')}</div>
        <RadioGroup value={type} onChange={onChange}>
          <FormControlLabel
            className={classes.item}
            value={TriggerFlowModeType.BOT}
            control={<Radio color="primary" />}
            label={
              <div className={classes.item}>{t('trigger-setting.bot')}</div>
            }
          />
          <FormControlLabel
            className={classes.item}
            value={TriggerFlowModeType.SUPERLINK}
            control={<Radio color="primary" />}
            label={
              <div className={classes.item}>
                {t('trigger-setting.superlink')}
              </div>
            }
          />
          <FormControlLabel
            className={classes.item}
            value={TriggerFlowModeType.PROCEDURE}
            control={<Radio color="primary" />}
            label={
              <div className={classes.item}>{t('trigger-setting.other')}</div>
            }
          />
          <FormControlLabel
            className={classes.item}
            value={TriggerFlowModeType.API}
            control={<Radio color="primary" />}
            label={
              <div className={classes.item}>{t('trigger-setting.api')}</div>
            }
          />
        </RadioGroup>
      </div>
      <div className={classes.sun}>
        <img src={isSun} alt="minus" />
        {t('trigger-setting.sun')}
      </div>
      <div className={classes.hint}>
        {t('trigger-setting.hint1')}
        <br />
        {t('trigger-setting.hint2')}
        <br />
        {t('trigger-setting.hint3')}
        <br />
        {t('trigger-setting.hint4')}
        <br />
        {t('trigger-setting.hint5')}
        <br />
        <br />
        {t('trigger-setting.hint6')}
      </div>
    </>
  );
};

export default Flow;
